module.exports = __webpack_public_path__ + "static/media/lapp_logo_white.3eacc0ee.png";